(() => {
  if (window.sdExtrasExtensionLoaded) return;
  window.sdExtrasExtensionLoaded = true;
  const root = () => window.Shopify?.routes?.root || '/';
  const api = async (path, payload) => {
    const response = await fetch(`${root()}${path}`, payload === undefined ? { headers: { Accept: 'application/json' }, cache: 'no-store' } : {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload)
    });
    const state = await response.json();
    if (!response.ok || state.status || state.errors) throw new Error(state.description || state.message || 'Die Auswahl konnte nicht gespeichert werden. Bitte erneut versuchen.');
    return state;
  };
  const groupChildren = (cart, group) => group ? cart.items.filter(item => item.properties?._sofa_extra_group === group && item.properties?._sofa_extra_item === 'true') : [];
  let pendingSelectionCart = null;
  const selectionCart = () => {
    if (!pendingSelectionCart) {
      pendingSelectionCart = api('cart.js').finally(() => { pendingSelectionCart = null; });
    }
    return pendingSelectionCart;
  };
  const newGroup = () => `sofa-${window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`}`;

  // Mirrors deliberately use different input classes: only the original buybox submits extras.
  function initProductChoices() {
    const region = document.getElementById('more-extras');
    const source = Array.from(document.querySelectorAll('sofa-extras')).find(el => el.closest('.product__info-container'));
    if (!region || !source) return;
    const inputs = Array.from(source.querySelectorAll('.sofa-extras__input:not([data-sofa-configurator-surcharge])'));
    if (!inputs.length) return;
    const cards = Array.from(region.querySelectorAll('.sdx-card'));
    const represented = new Set();
    const cardSkus = card => {
      const title = (card.querySelector('.sdx-card-title')?.textContent || '').toLowerCase();
      if (/usb/.test(title)) return ['EXTRA-USB', 'EXTRA-USB2'];
      if (/bettfunktion|schlaffunktion/.test(title)) return ['EXTRA-BETT'];
      if (/recliner/.test(title)) return ['EXTRA-RECLINER'];
      if (/multifunktions/.test(title)) return ['EXTRA-MULTI'];
      if (/getränke|kühler/.test(title)) return ['EXTRA-KUEHLER'];
      if (/wireless|kabellos/.test(title)) return ['EXTRA-WIRELESS'];
      if (/komfortpolster/.test(title)) return ['EXTRA-KOMFORT'];
      if (/trageservice/.test(title)) return ['EXTRA-TRAGE'];
      if (/couchtisch/.test(title)) return ['EXTRA-COUCHTISCH','EXTRA-COUCHTISCH-LED'];
      return [];
    };
    const makeChoice = (input, container) => {
      represented.add(input.value);
      if (Array.from(container.querySelectorAll('[data-sd-extra-mirror]')).some(el => el.value === input.value)) return;
      const label = document.createElement('label'); label.className = 'sd-extra-choice';
      const checkbox = document.createElement('input'); checkbox.type = 'checkbox'; checkbox.value = input.value;
      checkbox.dataset.sdExtraMirror = ''; checkbox.checked = input.checked; checkbox.disabled = input.disabled;
      const text = document.createElement('span'); text.textContent = input.dataset.label || '';
      const price = document.createElement('strong');
      price.textContent = input.disabled ? 'Derzeit nicht verfügbar' : `+ ${source.formatMoney ? source.formatMoney(Number(input.dataset.price)) : input.closest('label')?.querySelector('.sofa-extras__price')?.textContent?.replace(/^\+\s*/, '') || ''}`;
      label.append(checkbox, text, price); container.append(label);
      checkbox.addEventListener('change', () => {
        // Look up the current original input in case the theme editor replaced the buybox.
        const original = Array.from(source.querySelectorAll('.sofa-extras__input')).find(el => el.value === checkbox.value);
        if (!original || original.disabled) return;
        original.checked = checkbox.checked;
        original.dispatchEvent(new Event('change', { bubbles: true }));
        syncProductChoices();
      });
    };
    cards.forEach(card => {
      const matching = inputs.filter(input => cardSkus(card).includes(input.dataset.sku));
      if (!matching.length) return;
      let container = card.querySelector('.sd-extra-choices');
      if (!container) { container = document.createElement('div'); container.className = 'sd-extra-choices'; (card.querySelector('.sdx-body') || card).append(container); }
      matching.forEach(input => makeChoice(input, container));
    });
    const missing = inputs.filter(input => !represented.has(input.value));
    if (missing.length) {
      let fallback = region.querySelector('.sd-extra-fallback');
      if (!fallback) {
        fallback = document.createElement('div'); fallback.className = 'sd-extra-fallback';
        const heading = document.createElement('h3'); heading.textContent = 'Passende Ergänzungen auswählen';
        fallback.append(heading); (region.querySelector('.sdx-wrap') || region.querySelector('.collapsible-content__answer-inner') || region).append(fallback);
      }
      missing.forEach(input => makeChoice(input, fallback));
    }
    syncProductChoices();
  }
  function syncProductChoices() {
    const originals = Array.from(document.querySelectorAll('.product__info-container sofa-extras .sofa-extras__input'));
    document.querySelectorAll('#more-extras [data-sd-extra-mirror]').forEach(mirror => {
      const original = originals.find(el => el.value === mirror.value);
      mirror.checked = !!original?.checked; mirror.disabled = !original || original.disabled;
    });
  }
  document.addEventListener('sd:extras-updated', initProductChoices);
  document.addEventListener('change', event => { if (event.target.matches('.sofa-extras__input')) syncProductChoices(); });
  document.addEventListener('shopify:section:load', initProductChoices);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProductChoices); else initProductChoices();

  // Exposed as one cohesive operation for regression tests. Prices always come from Shopify.
  async function changeExtra(parentKey, parentGroup, option, enabled, choices, onGroup = () => {}) {
    let cart = await api('cart.js');
    let parent = cart.items.find(item => item.key === parentKey && item.properties?._sofa_extra_item !== 'true');
    if (!parent && parentGroup) parent = cart.items.find(item => item.properties?._sofa_extra_group === parentGroup && item.properties?._sofa_extra_item !== 'true');
    if (!parent) throw new Error('Der Artikel wurde inzwischen geändert. Bitte prüfe den aktualisierten Warenkorb.');
    let group = parent.properties?._sofa_extra_group;
    if (!group && !enabled) return '';
    if (!group) {
      group = newGroup();
      cart = await api('cart/change.js', { id: parent.key, quantity: parent.quantity, properties: { ...(parent.properties || {}), _sofa_extra_group: group } });
      parent = cart.items.find(item => item.properties?._sofa_extra_group === group && item.properties?._sofa_extra_item !== 'true');
      if (!parent) throw new Error('Der Artikel konnte nicht zugeordnet werden. Bitte erneut versuchen.');
    }
    onGroup(group);
    const children = groupChildren(cart, group);
    const selected = children.filter(item => String(item.variant_id) === option.id);
    if (!enabled) {
      for (const child of selected) await api('cart/change.js', { id: child.key, quantity: 0 });
      return group;
    }
    const exclusiveIds = choices.filter(choice => option.exclusive && choice.exclusive === option.exclusive && choice.id !== option.id).map(choice => choice.id);
    const conflicts = children.filter(child => exclusiveIds.includes(String(child.variant_id)));
    let added = false;
    if (!selected.length) {
      const properties = { _sofa_extra_group: group, _sofa_extra_item: 'true', 'Extra für': parent.product_title || parent.title };
      if (['EXTRA-COUCHTISCH', 'EXTRA-COUCHTISCH-LED'].includes(option.sku) && parent.variant_title && parent.variant_title !== 'Default Title') {
        properties['Anfertigung wie Sofa'] = parent.variant_title;
      }
      // Add first: a sold-out new choice must not remove the customer's existing option.
      try {
        await api('cart/add.js', { items: [{ id: Number(option.id), quantity: parent.quantity, properties }] });
      } catch (error) {
        // A lost response can follow a successful add. Reconcile instead of adding twice.
        const verified = await api('cart.js');
        const persisted = groupChildren(verified, group).find(item => String(item.variant_id) === option.id);
        if (!persisted || persisted.quantity !== parent.quantity) throw error;
      }
      added = true;
    } else if (selected[0].quantity !== parent.quantity) {
      await api('cart/change.js', { id: selected[0].key, quantity: parent.quantity });
    }
    try {
      for (const conflict of conflicts) {
        // Discounts and properties can change keys. Resolve the current key before removal.
        cart = await api('cart.js');
        const current = groupChildren(cart, group).find(item => item.variant_id === conflict.variant_id);
        if (current) await api('cart/change.js', { id: current.key, quantity: 0 });
      }
    } catch (error) {
      if (added) {
        const fresh = await api('cart.js');
        const newChild = groupChildren(fresh, group).find(item => String(item.variant_id) === option.id);
        if (newChild) await api('cart/change.js', { id: newChild.key, quantity: 0 });
      }
      throw error;
    }
    return group;
  }

  async function refreshCart() {
    const mainSection = document.getElementById('main-cart-items')?.dataset.id;
    const ids = ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text'];
    if (mainSection) ids.push(mainSection);
    const url = new URL(window.location.href); url.searchParams.set('sections', [...new Set(ids)].join(','));
    const response = await fetch(url, { cache: 'no-store' });
    if (!response.ok) throw new Error('Der Warenkorb konnte nicht neu geladen werden. Bitte lade die Seite neu.');
    const sections = await response.json();
    const replace = (selector, sectionId, sourceSelector = selector) => {
      const target = document.querySelector(selector);
      if (!target) return;
      const html = sections[sectionId];
      const fresh = html && new DOMParser().parseFromString(html, 'text/html').querySelector(sourceSelector);
      if (!fresh) throw new Error('Bitte lade die Seite neu, um den aktuellen Warenkorb zu sehen.');
      target.innerHTML = fresh.innerHTML;
    };
    replace('#CartDrawer', 'cart-drawer');
    replace('#cart-icon-bubble', 'cart-icon-bubble', '.shopify-section');
    replace('#cart-live-region-text', 'cart-live-region-text', '.shopify-section');
    if (mainSection) replace(`#shopify-section-${CSS.escape(mainSection)}`, mainSection);
    const drawer = document.querySelector('cart-drawer');
    const overlay = drawer?.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', () => drawer.close());
    if (drawer?.classList.contains('active') && typeof trapFocus === 'function') trapFocus(drawer.querySelector('#CartDrawer'), drawer.querySelector('.drawer__close'));
  }

  document.addEventListener('submit', event => {
    if ((window.sdCartExtrasBusy || window.sdCartExtrasNeedsReload) && (event.target.closest('cart-items, cart-drawer') || event.target.action?.includes('/cart/add'))) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('click', event => {
    if ((window.sdCartExtrasBusy || window.sdCartExtrasNeedsReload) && event.target.closest('cart-remove-button, [name="checkout"], a[href*="/checkout"]')) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);

  if (!customElements.get('sd-cart-extras')) customElements.define('sd-cart-extras', class extends HTMLElement {
    connectedCallback() {
      if (this._bound) return; this._bound = true;
      // AJAX section HTML and browser-restored form values can be stale. Reconcile
      // existing extras against the current cart whenever this widget is inserted.
      this.selectionRevision = 0;
      this.syncSelection();
      this.querySelector('[data-sd-show-all]')?.addEventListener('click', event => {
        const expanded = this.classList.toggle('is-expanded');
        event.currentTarget.setAttribute('aria-expanded', String(expanded));
        event.currentTarget.textContent = expanded ? 'Weniger anzeigen ↑' : 'Alle Ergänzungen ansehen →';
      });
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-sd-cart-extra]')) return;
        event.stopPropagation(); this.change(event.target);
      });
    }
    async syncSelection() {
      const revision = this.selectionRevision;
      try {
        const cart = await selectionCart();
        if (!this.isConnected || revision !== this.selectionRevision || window.sdCartExtrasBusy) return;
        const parent = cart.items.find(item => item.key === this.dataset.parentKey && item.properties?._sofa_extra_item !== 'true')
          || cart.items.find(item => this.dataset.parentGroup && item.properties?._sofa_extra_group === this.dataset.parentGroup && item.properties?._sofa_extra_item !== 'true');
        if (!parent) return;
        const group = parent.properties?._sofa_extra_group;
        if (group) this.dataset.parentGroup = group;
        const selected = new Set(groupChildren(cart, group).map(item => String(item.variant_id)));
        this.querySelectorAll('[data-sd-cart-extra]').forEach(input => {
          input.checked = selected.has(input.value);
          input.defaultChecked = input.checked;
          if (input.checked) input.closest('.sd-cart-extra-option')?.classList.remove('sd-cart-extra-option--more');
        });
      } catch (_) { /* Retain the server-rendered selection when offline. */ }
    }
    async change(input) {
      if (window.sdCartExtrasBusy || window.sdCartQuantityBusy || window.sdCartExtrasNeedsReload) { input.checked = !input.checked; return; }
      this.selectionRevision++;
      const enabled = input.checked;
      const option = { id: input.value, sku: input.dataset.sku, exclusive: input.dataset.exclusiveGroup };
      const choices = Array.from(this.querySelectorAll('[data-sd-cart-extra]')).map(el => ({ id: el.value, exclusive: el.dataset.exclusiveGroup }));
      let group = this.dataset.parentGroup;
      const key = this.dataset.parentKey;
      let message = enabled ? 'Deine Ergänzung wurde hinzugefügt.' : 'Die Ergänzung wurde entfernt.';
      let failed = false;
      window.sdCartExtrasBusy = true;
      document.documentElement.classList.add('sd-cart-extras-busy');
      const locked = Array.from(document.querySelectorAll('cart-items input, cart-items button, cart-drawer input, cart-drawer button, #main-cart-footer button')).map(el => [el, el.disabled]);
      locked.forEach(([el]) => { el.disabled = true; });
      try {
        group = await changeExtra(key, group, option, enabled, choices, value => { group = value; });
      } catch (error) { failed = true; message = error.message; }
      try { await refreshCart(); window.sdCartExtrasNeedsReload = false; }
      catch (error) {
        failed = true; message = error.message;
        // Never present an optimistic checkbox as saved after an uncertain request.
        const controls = document.querySelectorAll('sd-cart-extras input'); controls.forEach(el => { el.disabled = true; });
        const status = this.querySelector('.sd-cart-extras-status');
        if (status) { status.hidden = false; status.textContent = message; status.classList.add('is-error'); }
        window.sdCartExtrasNeedsReload = true;
      } finally {
        locked.forEach(([el, disabled]) => { if (el.isConnected && !window.sdCartExtrasNeedsReload) el.disabled = disabled; });
        window.sdCartExtrasBusy = false;
        document.documentElement.classList.remove('sd-cart-extras-busy');
      }
      const widgets = Array.from(document.querySelectorAll('sd-cart-extras'));
      const updated = widgets.filter(el => (group && el.dataset.parentGroup === group) || el.dataset.parentKey === key);
      updated.forEach(el => {
        const status = el.querySelector('.sd-cart-extras-status');
        status.hidden = false; status.textContent = message; status.classList.toggle('is-error', failed);
        if (window.sdCartExtrasNeedsReload) {
          const reload = document.createElement('a'); reload.href = window.location.href; reload.textContent = ' Seite neu laden'; status.append(reload);
        }
      });
      const visible = updated.find(el => el.getClientRects().length);
      const focus = visible && Array.from(visible.querySelectorAll('[data-sd-cart-extra]')).find(el => el.value === option.id);
      focus?.focus({ preventScroll: true });
    }
  });
  window.SDExtrasExtension = { changeExtra, initProductChoices, refreshCart };
})();
